/* Lucky Cosmos mobile layer for Round Top Finds 2.0.
   Phones: arrow rows with a counter under swipe rows, RTF Cards: Image opens
   on card 2, one-time swipe nudge, Video slideshow arrows and no autoplay.
   Desktop: Featured blog posts arrows lined up with the post title.
   Loaded once from layout/theme.liquid. */
(function () {
  'use strict';
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ROWS = '.rtf-cards-image .rtf-cards__grid, .rtf-tab-blogs .grid--mobile-slider, .shopify-section[id*="section_blog_list"] .grid--mobile-slider';
  var L = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var R = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>';
  var interacted = false;

  function cards(track) {
    return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
  }
  function nearest(track) {
    var items = cards(track), mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
    items.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < dist) { dist = d; best = i; } });
    return best;
  }
  function goTo(track, i) {
    var items = cards(track); if (!items.length) return;
    i = Math.max(0, Math.min(items.length - 1, i));
    var c = items[i];
    track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
  }
  function makeRow(onPrev, onNext) {
    var row = document.createElement('div');
    row.className = 'lc-arrows';
    row.innerHTML = '<button type="button" aria-label="Previous">' + L + '</button><span class="lc-count" aria-live="polite"></span><button type="button" aria-label="Next">' + R + '</button>';
    var b = row.querySelectorAll('button');
    b[0].addEventListener('click', function () { interacted = true; onPrev(); });
    b[1].addEventListener('click', function () { interacted = true; onNext(); });
    return row;
  }
  function setupRow(track) {
    if (track.dataset.lcRow) return;
    track.dataset.lcRow = '1';
    var row = makeRow(function () { goTo(track, nearest(track) - 1); }, function () { goTo(track, nearest(track) + 1); });
    track.insertAdjacentElement('afterend', row);
    var btn = row.querySelectorAll('button'), count = row.querySelector('.lc-count');
    function update() {
      var n = cards(track).length, i = nearest(track);
      row.style.display = n > 1 ? '' : 'none';
      count.textContent = (i + 1) + ' / ' + n;
      btn[0].disabled = i <= 0; btn[1].disabled = i >= n - 1;
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    track.lcUpdate = update;
    update();
  }
  function startOnCard2(track) {
    if (!PHONE.matches || track.dataset.lcStart) return;
    track.dataset.lcStart = '1';
    var items = cards(track); if (items.length < 3) return;
    var c = items[1];
    track.scrollLeft = c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2;
  }

  /* One-time nudge: each row slides about 70px and back once when it first comes into view. */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting || e.intersectionRatio < 0.6 || e.target.dataset.lcNudged) return;
      e.target.dataset.lcNudged = '1'; io.unobserve(e.target);
      setTimeout(function () { nudge(e.target); }, 450);
    });
  }, { threshold: [0.6] }) : null;
  function nudge(el) {
    if (interacted || REDUCED.matches || !PHONE.matches || el.scrollWidth <= el.clientWidth + 4) return;
    var start = el.scrollLeft, dist = Math.min(72, el.clientWidth * 0.18), snap = el.style.scrollSnapType, t0 = null, dur = 1100;
    el.style.scrollSnapType = 'none';
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), k = p < 0.45 ? ease(p / 0.45) : 1 - ease((p - 0.45) / 0.55);
      el.scrollLeft = start + dist * k;
      if (p < 1) requestAnimationFrame(step); else { el.scrollLeft = start; el.style.scrollSnapType = snap; }
    }
    requestAnimationFrame(step);
  }
  /* Tab Blogs: a tab's row only has size once its tab is shown. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.rtf-tab-blogs .tab-link')) return;
    setTimeout(function () { document.querySelectorAll(ROWS).forEach(function (t) { if (t.lcUpdate) t.lcUpdate(); }); }, 80);
  });

  ['touchstart', 'wheel', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function () { interacted = true; }, { once: true, passive: true });
  });

  /* Video slideshow on phones: arrows with a counter instead of dots, and no autoplay. */
  function setupSlideshow(section) {
    if (section.dataset.lcVs) return;
    var carousel = section.querySelector('.vs-carousel'), prev = section.querySelector('[data-vs-prev]'), next = section.querySelector('[data-vs-next]'), dots = section.querySelectorAll('[data-vs-dot]');
    if (!carousel || !prev || !next || dots.length < 2) return;
    section.dataset.lcVs = '1';
    var row = makeRow(function () { prev.click(); }, function () { next.click(); });
    carousel.insertAdjacentElement('afterend', row);
    var count = row.querySelector('.lc-count');
    function update() {
      var i = 0; dots.forEach(function (d, k) { if (d.classList.contains('is-active')) i = k; });
      count.textContent = (i + 1) + ' / ' + dots.length;
    }
    dots.forEach(function (d) { new MutationObserver(update).observe(d, { attributes: true, attributeFilter: ['class'] }); });
    update();
    /* The section pauses its timer while "hovered", so on phones it stays hovered. */
    if (PHONE.matches) {
      carousel.dispatchEvent(new Event('mouseenter'));
      window.addEventListener('load', function () { carousel.dispatchEvent(new Event('mouseenter')); });
      carousel.addEventListener('mouseleave', function () { if (PHONE.matches) carousel.dispatchEvent(new Event('mouseenter')); });
    }
  }

  /* Featured blog posts on desktop: arrows start at the left edge of the showing slide's title.
     Measured against the title's own slide, so it does not matter where the slider has moved to,
     and it follows the text column when a slide puts the photo on the left. */
  function alignOne(s) {
    if (PHONE.matches) return;
    var p = s.querySelector('.flickity-button.previous'), n = s.querySelector('.flickity-button.next');
    var slide = s.querySelector('.editorial__slide.is-selected') || s.querySelector('.editorial__slide');
    var title = slide && slide.querySelector('.editorial__title');
    if (!p || !n || !title || !p.offsetParent) return;
    var inSlide = title.getBoundingClientRect().left - slide.getBoundingClientRect().left;
    var left = inSlide + s.getBoundingClientRect().left - p.offsetParent.getBoundingClientRect().left;
    p.style.left = left + 'px'; p.style.right = 'auto';
    n.style.left = (left + 52) + 'px'; n.style.right = 'auto';
  }
  function watchFeatured(s) {
    if (s.dataset.lcAlign) return;
    s.dataset.lcAlign = '1';
    var raf = 0;
    var mo = new MutationObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { alignOne(s); }); });
    s.querySelectorAll('.editorial__slide').forEach(function (sl) { mo.observe(sl, { attributes: true, attributeFilter: ['class'] }); });
  }
  function alignFeatured(root) {
    (root || document).querySelectorAll('.featured-posts .editorial__slider').forEach(function (s) {
      watchFeatured(s);
      alignOne(s);
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll(ROWS).forEach(function (track) {
      if (track.matches('.rtf-cards__grid')) startOnCard2(track);
      setupRow(track);
      if (io) io.observe(track);
    });
    root.querySelectorAll('[data-section-type="video-slideshow"]').forEach(setupSlideshow);
    alignFeatured(root);
    setTimeout(function () { alignFeatured(root); }, 800);
  }

  /* Wait for DOMContentLoaded so the sections' own scripts have bound their listeners first. */
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  window.addEventListener('load', function () { alignFeatured(); });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { alignFeatured(); }, 150); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Header search dropdown: match names inside articles, not only their titles.
   The theme asks /search/suggest for titles only; this adds the body field to that one request. */
(function () {
  var nativeFetch = window.fetch;
  if (!nativeFetch) return;
  var FIELDS = 'resources[options][fields]=title,author,body,tag,product_type,variants.title,vendor&';
  window.fetch = function (input, init) {
    if (typeof input === 'string' && input.indexOf('/search/suggest') !== -1 && input.indexOf('section_id=predictive-search') !== -1 && input.indexOf('[options][fields]') === -1) {
      input = input.replace('section_id=predictive-search', FIELDS + 'section_id=predictive-search');
    }
    return nativeFetch.call(window, input, init);
  };
})();

/* Phone menu: a menu item with sub-links opens as an accordion under itself (Ash 9/24 launch night).
   Tapping the arrow shows or hides its links and the rest of the menu stays in view.
   Tapping the item's name goes to its page. Replaces Broadcast's slide-over submenu. */
(function () {
  'use strict';
  var SEL = '.drawer--header mobile-sliderule';
  function setup(root) {
    (root || document).querySelectorAll(SEL).forEach(function (m) {
      if (m.dataset.lcAcc) return;
      var btn = m.querySelector(':scope > button.sliderow'), panel = m.querySelector(':scope > .sliderule__panel');
      if (!btn || !panel) return;
      m.dataset.lcAcc = '1';
      m.classList.add('lc-acc');
      btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL + '.lc-acc > button.sliderow');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var m = btn.parentElement;
    var link = m.querySelector('.sliderow--back a.sliderow__title');
    if (!e.target.closest('.sliderule__chevron') && e.detail !== 0 && link) { window.location.href = link.href; return; }
    var open = !m.classList.contains('lc-acc-open');
    m.classList.toggle('lc-acc-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();

/* Phone menu scrolling on iPhone (Ash 9/24 launch night: "it freezes up").
   Broadcast's scroll lock watches every finger movement on the page and cancels any that starts
   at the top or bottom edge of the menu. On an iPhone, once the first movement of a swipe is
   cancelled, the whole swipe is dead, so the menu looks frozen. This keeps the menu's own swipes
   away from that lock and keeps the menu one pixel off its edges when a touch starts, so iPhone
   never hands the swipe to the page behind it. */
(function () {
  'use strict';
  function bind(sc) {
    if (!sc || sc.dataset.lcScroll) return;
    sc.dataset.lcScroll = '1';
    sc.addEventListener('touchstart', function () {
      var max = sc.scrollHeight - sc.clientHeight;
      if (max <= 0) return;
      if (sc.scrollTop <= 0) sc.scrollTop = 1;
      else if (sc.scrollTop >= max) sc.scrollTop = max - 1;
    }, { passive: true });
    sc.addEventListener('touchmove', function (e) {
      if (sc.scrollHeight > sc.clientHeight) e.stopPropagation();
    }, { passive: true });
  }
  function setup(root) {
    (root || document).querySelectorAll('.drawer--header .drawer__content__scroll').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
